import { motion } from "framer-motion";

const OUTLINE = "M 430 60 L 520 120 L 560 180 L 625 170 L 660 220 L 705 250 L 762 262 L 820 240 L 862 198 L 905 185 L 945 175 L 985 235 L 950 300 L 905 322 L 862 302 L 840 380 L 800 425 L 745 520 L 700 640 L 645 760 L 560 905 L 480 865 L 420 745 L 380 600 L 330 500 L 260 425 L 180 385 L 215 305 L 300 225 L 360 140 Z";

const PINS = {
  "Hyderabad": { x: 475, y: 615, label: [490, 610] },
  "Mumbai": { x: 345, y: 520, label: [255, 535] },
  "Bengaluru": { x: 465, y: 745, label: [480, 760] },
  "Delhi NCR": { x: 480, y: 255, label: [495, 250] },
  "Chennai": { x: 565, y: 765, label: [580, 780] },
  "Pune": { x: 370, y: 555, label: [385, 575] },
  "Ahmedabad": { x: 330, y: 430, label: [240, 445] },
  "Kolkata": { x: 815, y: 420, label: [700, 435] },
};

const STATUS_STYLE = {
  "Operating": { fill: "#ffffff", ring: "rgba(255,255,255,0.35)", pulse: true },
  "Upcoming": { fill: "rgba(255,255,255,0.45)", ring: "rgba(255,255,255,0.15)", pulse: false },
  "Pop-Up": { fill: "rgba(255,255,255,0.75)", ring: "rgba(255,255,255,0.25)", pulse: true },
};

export const IndiaMap = ({ locations = [], selected, onSelect }) => (
  <div className="relative" data-testid="india-map">
    <svg viewBox="0 0 1050 980" className="w-full h-auto" role="img" aria-label="Map of Vrova locations across India">
      <defs>
        <radialGradient id="mapGlow" cx="50%" cy="45%" r="65%">
          <stop offset="0%" stopColor="rgba(96,120,255,0.10)" />
          <stop offset="100%" stopColor="transparent" />
        </radialGradient>
      </defs>
      <rect width="1050" height="980" fill="url(#mapGlow)" />
      <motion.path
        d={OUTLINE}
        fill="rgba(255,255,255,0.025)"
        stroke="rgba(255,255,255,0.22)"
        strokeWidth="1.5"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 2.4, ease: "easeInOut" }}
      />
      {locations.map((loc) => {
        const pin = PINS[loc.city];
        if (!pin) return null;
        const style = STATUS_STYLE[loc.status] || STATUS_STYLE["Upcoming"];
        const active = selected === loc.slug;
        return (
          <g key={loc.slug}
            onClick={() => onSelect?.(loc.slug)}
            className="cursor-pointer"
            data-testid={`map-pin-${loc.slug}`}
            role="button" aria-label={`${loc.city} — ${loc.status}`}>
            {style.pulse && (
              <circle cx={pin.x} cy={pin.y} r="10" fill="none" stroke={style.ring} strokeWidth="1.5">
                <animate attributeName="r" values="8;26" dur="2.2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.9;0" dur="2.2s" repeatCount="indefinite" />
              </circle>
            )}
            <circle cx={pin.x} cy={pin.y} r={active ? 16 : 12} fill="none" stroke={active ? "rgba(255,255,255,0.6)" : style.ring} strokeWidth="1.5" />
            <circle cx={pin.x} cy={pin.y} r={active ? 6.5 : 5} fill={style.fill} style={{ transition: "all .3s" }} />
            <text x={pin.label[0]} y={pin.label[1]} fill={active ? "#ffffff" : "rgba(255,255,255,0.55)"}
              fontSize="17" fontFamily="Space Mono, monospace" letterSpacing="1">
              {loc.city.toUpperCase()}
            </text>
          </g>
        );
      })}
    </svg>
    <div className="flex flex-wrap gap-5 mt-4 justify-center">
      {Object.entries(STATUS_STYLE).map(([status, s]) => (
        <span key={status} className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.15em] text-zinc-500">
          <span className="w-2 h-2 rounded-full" style={{ background: s.fill }} />
          {status}
        </span>
      ))}
    </div>
  </div>
);
